import React from 'react';
import Icon from './Icon';

export default function TestimonialCard({ testimonial }) {
  const { name, initials, role, level, levelColor, discount, text, metric } = testimonial;
  return (
    <article className="card testimonial-card">
      <div className="testimonial-quote">
        <Icon name="quote" size={28} />
      </div>

      <p className="testimonial-text">{text}</p>

      <div className="testimonial-metric">
        <Icon name="hand-coins" size={16} />
        <span>{metric}</span>
      </div>

      <div className="testimonial-footer">
        <div className="testimonial-avatar" aria-hidden="true">{initials}</div>
        <div className="testimonial-meta">
          <div className="testimonial-name">{name}</div>
          <div className="testimonial-role">{role}</div>
        </div>
        <div className="testimonial-level" style={{ borderColor: levelColor, color: levelColor }}>
          {level} · {discount}
        </div>
      </div>
    </article>
  );
}
